export default __webpack_public_path__ + "static/media/no-flag.0223ab0e.svg";